import React, { ButtonHTMLAttributes } from "react";
import styled from "styled-components";
import { Device } from "../../../../components/device";

interface BurgerButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>
{
    active?: boolean;
    mobileColor?: string;
}

const Burger = styled.button`
    box-sizing: border-box;
    width: 60px;
    height: 50px;
    flex-flow: column;
    justify-content: space-around;
    align-items: center;
    padding: 15px 0;
    cursor: pointer;
    background: transparent;
    display: flex;
    border: none;
    position: relative;
    left: -1rem;
    &:hover,
    &:focus {
        outline: none;
    }
    ${Device.tabletLandscape} {
        display: none;
    }
`;

const BurgerLine = styled.div`
    width: 26px;
    height: 3px;
    background-color: currentColor;
    margin: 3px auto;
    pointer-events: none;
    transition: transform .15s;
    
    .burger--active > & {
        :nth-child(2n) {
            transform: rotate(-45deg) translate(-1px, 5px);
        }
        :last-child {
            width: 26px;
            transform: rotate(45deg) translate(-3px,-6px);
            left: 0;
        }
    }
    &:nth-child(3){
        width: 20px;
        position: relative; 
        left: -3px;
    }
    &:nth-child(1){
        display: none;
    }
`;

const BurgerButton = (props: BurgerButtonProps) => (
    <Burger className={props.active ? "burger--active" : ""} {...props}>
        <BurgerLine style={{ backgroundColor: props.mobileColor ? props.mobileColor : "currentColor" }} />
        <BurgerLine style={{ backgroundColor: props.mobileColor ? props.mobileColor : "currentColor" }} />
        <BurgerLine style={{ backgroundColor: props.mobileColor ? props.mobileColor : "currentColor" }} />
    </Burger>
);

export default BurgerButton;
